import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { Badge } from '../ui/Badge';
interface TeamMemberProps {
  member: {
    name: string;
    role: string;
    bio: string;
    image: string;
    petName?: string;
    petType?: string;
    social?: {
      linkedin?: string;
      twitter?: string;
      email?: string;
    };
  };
}
export function TeamMember({
  member
}: TeamMemberProps) {
  return <div className="group relative" data-id="element-150">
      <div className="relative overflow-hidden rounded-[2rem] bg-gray-100 aspect-[3/4] mb-6 shadow-soft-md" data-id="element-151">
        <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" data-id="element-152" />

        {/* Overlay Info */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6" data-id="element-153">
          <p className="text-white/90 text-sm mb-4 line-clamp-3" data-id="element-154">
            "{member.bio}"
          </p>

          <div className="flex gap-3" data-id="element-155">
            {member.social?.linkedin && <a href={member.social.linkedin} className="p-2 bg-white/20 hover:bg-white/40 rounded-full text-white transition-colors backdrop-blur-sm" data-id="element-156">
                <Linkedin className="w-4 h-4" data-id="element-157" />
              </a>}
            {member.social?.twitter && <a href={member.social.twitter} className="p-2 bg-white/20 hover:bg-white/40 rounded-full text-white transition-colors backdrop-blur-sm" data-id="element-158">
                <Twitter className="w-4 h-4" data-id="element-159" />
              </a>}
            {member.social?.email && <a href={`mailto:${member.social.email}`} className="p-2 bg-white/20 hover:bg-white/40 rounded-full text-white transition-colors backdrop-blur-sm" data-id="element-160">
                <Mail className="w-4 h-4" data-id="element-161" />
              </a>}
          </div>
        </div>

        {/* Pet Badge */}
        {member.petName && <div className="absolute top-4 right-4 translate-x-4 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300 delay-100" data-id="element-162">
            <Badge variant="secondary" size="sm" className="shadow-lg backdrop-blur-md bg-white/90" data-id="element-163">
              Humano de {member.petName}
            </Badge>
          </div>}
      </div>

      <h3 className="text-xl font-bold text-charcoal-900 font-serif mb-1 group-hover:text-primary-700 transition-colors" data-id="element-164">
        {member.name}
      </h3>
      <p className="text-primary-600 font-medium text-sm uppercase tracking-wide" data-id="element-165">
        {member.role}
      </p>
    </div>;
}